export const isLocalHost = () => {
  return location.hostname === "localhost" || location.hostname === "127.0.0.1";
};

export const getLoginUrl = (lang: string, hidePrompt: boolean) => {
  const prompt = hidePrompt ? "&prompt=none" : "&prompt=select_account";
  return isLocalHost()
    ? `/.auth/login/aad`
    : `/.auth/login/aadb2c?ui_locales=${lang}${prompt}`;
};
